module.exports = __webpack_public_path__ + "static/japan01-a44fe8db26e2e1a794e5e16e0868d990.jpg";